<template>
<div>


  <section class="content">

      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">EmployeeSalaryDetails List</h3>
           
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
         

<div class="row">
        <!-- /.col -->
        <div class="col-md-3">
          <div class="card card-primary">
            <div class="card-header">
              <h3 class="card-title">Employee Salary Record</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <form role="form">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- text input -->

                    <div class="form-group">
                      <label>Employee Code<span class="red">*</span></label>
                      <select
                        v-model="form.employee_id"
                        name="employee_id"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('employee_id'),
                        }"
                      >
                        <option v-if="!form.employee_id" selected value="">
                          Select Employee
                        </option>
                        <option
                          :value="staff.user.id"
                          v-for="staff in staffs"
                          :key="staff.id"
                        >
                          {{ staff.user.name }} - {{ staff.user.code }}
                        </option>
                      </select>
                      <has-error :form="form" field="employee_id"></has-error>
                    </div>

                    <div class="form-group">
                      <label>From Date <span class="red">*</span></label>
                      <input
                        type="date"
                        v-model="form.fromDate"
                        name="fromDate"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('fromDate') }"
                      />

                      <has-error :form="form" field="fromDate"></has-error>
                    </div>
                    <div class="form-group">
                      <label>To Date <span class="red">*</span></label>
                      <input
                        type="date"
                        v-model="form.toDate"
                        name="toDate"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('toDate') }"
                      />

                      <has-error :form="form" field="toDate"></has-error>
                    </div>

                    <div class="form-group">
                      <label for=""></label>
                      <button type="button" class="btn btn-success">
                        Get Record
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /.col -->
        <div class="col-md-9">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Employee Salary Disbursement Details</h3>
              <span class="float-right"
                ><button class="btn btn-sm btn-success" @click="newModal">
                  <i class="fa fa-plus"></i></button
              ></span>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-sm">
              <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'id'">
                    <button
                      @click="viewModal(props.row)"
                      class="btn btn-info btn-sm"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <button
                      @click="editModal(props.row)"
                      class="btn btn-success btn-sm"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      </div>
               
          
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all EmployeeSalaryDetails
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>



      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 v-show="!editMode" class="modal-title">
                Add Salary Disbursement
              </h4>
              <h4 v-show="editMode" class="modal-title">
                Update Salary Disbursement
              </h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form
              @submit.prevent="
                editMode ? updateSalaryRecord() : createEmployeeRecord()
              "
            >
              <div class="modal-body">
                <!-- right column -->
                <div class="col-md-12">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label
                              >Employee Code<span class="red">*</span></label
                            >
                            <select
                              v-model="form.employee_id"
                              name="employee_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('employee_id'),
                              }"
                            >
                              <option
                                v-if="!form.employee_id"
                                selected
                                value=""
                              >
                                Select Employee
                              </option>
                              <option
                                :value="staff.user.id"
                                v-for="staff in staffs"
                                :key="staff.id"
                              >
                                {{ staff.user.name }} - {{ staff.user.code }}
                              </option>
                            </select>
                            <has-error
                              :form="form"
                              field="employee_id"
                            ></has-error>
                          </div>

                          <div class="form-group">
                            <label>Branch <span class="red">*</span></label>
                            <select
                              v-model="form.branch_id"
                              name="branch_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_id'),
                              }"
                            >
                              <option v-if="!form.branch_id" selected value="">
                                Select Company Branch
                              </option>
                              <option
                                :value="branch.id"
                                v-for="branch in branches"
                                :key="branch.id"
                              >
                                {{ branch.name }}
                              </option>
                            </select>
                            <has-error
                              :form="form"
                              field="branch_id"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Salary<span class="red">*</span></label>
                            <input
                              type="text"
                              v-model="form.salary"
                              name="salary"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('salary'),
                              }"
                            />

                            <has-error :form="form" field="salary"></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Transaction Date
                              <span class="red">*</span></label
                            >
                            <input
                              type="date"
                              v-model="form.transactionDate"
                              name="transactionDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'transactionDate'
                                ),
                              }"
                            />

                            <has-error
                              :form="form"
                              field="transactionDate"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Payment Mode<span class="red">*</span></label
                            >
                            <input
                              type="text"
                              v-model="form.payMode"
                              name="payMode"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('payMode'),
                              }"
                            />

                            <has-error :form="form" field="payMode"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Bank Name</label>
                            <select
                              v-model="form.bank_id"
                              name="bank_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('bank_id'),
                              }"
                            >
                              <option v-if="!form.bank_id" selected value="">
                                Select Bank
                              </option>
                              <option
                                :value="bank.id"
                                v-for="bank in banks"
                                :key="bank.id"
                              >
                                {{ bank.name }}
                              </option>
                            </select>
                            <has-error :form="form" field="bank_id"></has-error>
                          </div>

                          <div class="form-group">
                            <label
                              >Account Number<span class="red">*</span></label
                            >
                            <input
                              type="text"
                              v-model="form.savingAcccountNo"
                              name="savingAcccountNo"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'savingAcccountNo'
                                ),
                              }"
                            />

                            <has-error
                              :form="form"
                              field="savingAcccountNo"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label
                              >Cheque Number<span class="red">*</span></label
                            >
                            <input
                              type="text"
                              v-model="form.chequeNo"
                              name="chequeNo"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('chequeNo'),
                              }"
                            />

                            <has-error
                              :form="form"
                              field="chequeNo"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Cheque Date<span class="red">*</span></label>
                            <input
                              type="date"
                              v-model="form.chequeDate"
                              name="chequeDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('chequeDate'),
                              }"
                            />

                            <has-error
                              :form="form"
                              field="chequeDate"
                            ></has-error>
                          </div>

                          <div class="form-group">
                            <label
                              >Transfer Date<span class="red">*</span></label
                            >
                            <input
                              type="date"
                              v-model="form.transferDate"
                              name="transferDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('transferDate'),
                              }"
                            />

                            <has-error
                              :form="form"
                              field="transferDate"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >UTR Transaction Number<span class="red"
                                >*</span
                              ></label
                            >
                            <input
                              type="text"
                              v-model="form.utrTransactionNo"
                              name="utrTransactionNo"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'utrTransactionNo'
                                ),
                              }"
                            />

                            <has-error
                              :form="form"
                              field="utrTransactionNo"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Transfer Mode<span class="red">*</span></label
                            >
                            <input
                              type="text"
                              v-model="form.transferMode"
                              name="transferMode"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('transferMode'),
                              }"
                            />

                            <has-error
                              :form="form"
                              field="transferMode"
                            ></has-error>
                          </div>

                          <div class="form-group">
                            <label
                              >Select Status <span class="red">*</span></label
                            >
                            <select
                              v-model="form.status"
                              name="status"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                            >
                              <option v-if="!form.status" selected value="">
                                Select Status
                              </option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success"
                >
                  CREATE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-success">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Salary Disbursement Details</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div
                      class="card-body box-profile"
                      v-if="salaryInfo.employee"
                    >
                      <ul class="list-group list-group-unbordered mb-3">
                        <li class="list-group-item">
                          <b>Employee Name</b
                          ><a class="float-right">{{
                            salaryInfo.employee.name
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Employee Code</b>
                          <a class="float-right">{{
                            salaryInfo.employee.code
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Branch</b>
                          <a class="float-right">{{
                            salaryInfo.branch.name
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Salary</b>
                          <a class="float-right">{{ salaryInfo.salary }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Transaction Date</b>
                          <a class="float-right">{{
                            salaryInfo.transactionDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Payment Mode</b
                          ><a class="float-right">{{ salaryInfo.payMode }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Bank Name</b>
                          <span v-for="bank in banks" :key="bank.id">
                            <a
                              class="float-right"
                              v-if="bank.id == salaryInfo.bank_id"
                              >{{ bank.name }}</a
                            >
                          </span>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul class="list-group list-group-unbordered mb-3">
                        <li class="list-group-item">
                          <b>Account Number</b>
                          <a class="float-right">{{
                            salaryInfo.savingAcccountNo
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Cheque Number</b>
                          <a class="float-right">{{ salaryInfo.chequeNo }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Cheque Date</b>
                          <a class="float-right">{{ salaryInfo.chequeDate }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Transfer Date</b>
                          <a class="float-right">{{
                            salaryInfo.transferDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>UTR Transaction Number</b>
                          <a class="float-right">{{
                            salaryInfo.utrTransactionNo
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Transfer Mode</b>
                          <a class="float-right">{{
                            salaryInfo.transferMode
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Status</b>
                          <a
                            class="float-right"
                            v-if="salaryInfo.status == 'active'"
                            ><span class="badge badge-success">Active</span></a
                          >
                          <a class="float-right" v-else
                            ><span class="badge badge-danger">InActive</span></a
                          >
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->

</div>
</template>

<script>
export default {
  name: 'EmployeeSalaryDetails',
  data () {
    return {
      form: new Form({
        id: '',
        name: '',
        date: '',
        employee_id: '',
        branch_id: '',
        salary: '',
        transactionDate: new Date().toISOString().substr(0, 10),
        payMode: '',
        bank_id: '',
        chequeNo: '',
        chequeDate: new Date().toISOString().substr(0, 10),
        transferDate: new Date().toISOString().substr(0, 10),
        utrTransactionNo: '',
        transferMode: '',
        savingAcccountNo: '',
        status: ''
      }),
      editMode: false,
      staffs: {},
      branches: {},
      banks: {},
      salaryInfo: {},
      columns: [
        {
          label: 'EMP CODE',
          field: 'employee.code'
        },

        {
          label: 'EMP NAME',
          field: 'employee.name'
        },
        {
          label: 'BRANCH NAME',
          field: 'branch.name'
        },
        {
          label: 'AMOUNT',
          field: 'salary'
        },
        {
          label: 'TRANS DATE',
          field: 'transactionDate'
        },

        {
          label: 'REMARK',
          field: 'remark'
        },
        {
          label: 'PAYMENT MODE',
          field: 'payMode'
        },
        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],

      rows: []
    }
  },
  methods: {
    newModal () {
      this.form.reset()
      this.editMode = false
      $('#newModal').modal('show')
    },
    editModal (row) {
      this.form.reset()
      this.editMode = true
      $('#newModal').modal('show')
      this.form.fill(row)
    },
    viewModal (row) {
      $('#viewModal').modal('show')
      this.salaryInfo = row
    },
    createEmployeeRecord () {
      this.$axios
        .post('salarydisbursement', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Staff Salary Disbursment Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    updateSalaryRecord () {
      this.$axios
        .put('salarydisbursement/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Staff Salary Disbursment Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadStaff () {
      this.$axios
        .get('staff', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadBranch () {
      this.$axios
        .get('branch?status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadBank () {
      this.$axios
        .get('bank?status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.banks = data.data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadData () {
      this.$axios
        .get('salarydisbursement', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.rows = data.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadData()
    this.loadStaff()
    this.loadBranch()
    this.loadBank()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// EmployeeSalaryDetails.vue?2ae765d6